import React, { Component } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl,mediaUrl } from'../Config/Config';


import {GET_ADDLOANCONFIG }  from '../../actions'; 

class Edit extends Component {
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		const LoanConfigId = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

		this.state = {
			label:'',			
			amount:'',
			percentage:'',
			amount_type:'',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue : 'active',
			selectedPlanOption: "",
			selectedPlanvalue: "",
			selectedrequirmentvalue: "",
			c_loanconfig_id: LoanConfigId,
			getrequireddocument:[],
			Loading:false,
			lt_icontype:"normal",

			image_preview: "",
			image_name: "",
			image: "",
			fileExtension: "",
			image_type:"",
			old_image: "",
			
			imagesvg_preview: "",
			imagesvg_name: "",
			imagesvg: "",
			imagesvg_fileExtension: "",
			enableuploadgalleyImage: false,
			enableuploadgalleyImageSvg: false,
			imagelist: [],
			selectedImage: null,
			unlinkImage: null,
			imageUsageMessage: '',
			showUnlinkConfirm: false,
			showUsageWarning: false,
			image_svg_type:"",
			old_svgimage: "",
			starting_amount:'',
			ending_amount: '',
			showinTab: "no",
			showinFormField: "no",
			starting_amount_type: "K",
			ending_amount_type: "K"
		};
		
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);

		var qs = require('qs');
		var loanconfigId = this.state.c_loanconfig_id;

		axios.get(apiUrl+"loantypes/listdetail?id="+loanconfigId).then(res => {
			const formdata = res.data.documentlist;
			console.log(formdata, 'form---data');
			
			if(formdata.category != ''){
				this.setState({selectedPlanOption:{value: formdata.category, label: formdata.category}});
			}
			if(formdata.status === 'A'){
				this.setState({selectedvalue:'active',selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedvalue:'inactive',selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
			this.setState({name:formdata.lt_name});				
			this.setState({selectedPlanvalue: formdata.category});
			this.setState({sort_order: formdata.lt_sort_order});
			this.setState({selectedrequirmentid:formdata.requirements});
			this.setState({selectedrequirmentvalue:formdata.requirements});
			this.setState({bank_statement_count:formdata.bank_statement_count});
			const startingAmt = formdata.display_starting_amount?.match(/^(\d+)([A-Za-z]+)$/);

			const starting_amount = startingAmt ? startingAmt[1] : "";
			const starting_amount_type = startingAmt ? startingAmt[2] : "K";
			const endingAmt = formdata.display_ending_amount?.match(/^(\d+)([A-Za-z]+)$/);

			const ending_amount = endingAmt ? endingAmt[1] : "";
			const ending_amount_type = endingAmt ? endingAmt[2] : "K";	
			
			this.setState({
				lt_icontype:formdata.lt_icontype ? formdata.lt_icontype : "normal",
				old_image:formdata.lt_icon,
				old_svgimage:formdata.lt_svgicon,
				starting_amount:starting_amount,
				starting_amount_type:starting_amount_type,
				ending_amount:ending_amount,
				ending_amount_type:ending_amount_type,
				showinTab:formdata.showinTab,
                showinFormField:formdata.showinFormField,
				image_preview:formdata.lt_icon!=null && formdata.lt_icon!=""?`${mediaUrl}tabicons/${formdata.lt_icon}`:"",
				imagesvg_preview:formdata.lt_svgicon!=null && formdata.lt_svgicon!=""?`${mediaUrl}tabicons/${formdata.lt_svgicon}`:"",
			});
				
			
		}); 
    }
	

	handleChange = selectedOption => {
		
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
   	};
	handlecatChange = selOption => {
		this.setState({selectedPlanOption:selOption})
			this.setState({  selectedPlanvalue : selOption.value});
    };
   handleInputChange(event) {

      const {name, type, checked, value} = event.target; 
	    if (name === "starting_amount" || name === "ending_amount") {
			// Allow numbers and decimal point
			if (!/^\d*\.?\d*$/.test(value)) {
			return;
			}
		}
       this.setState({
			[name]: type === "checkbox" ? (checked ? "yes" : "no") : value,
		});
    }
	onChangeHandler = (event) => {
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split(".").pop();
		console.log(extension,"extension")
		reader.onloadend = () => {
		this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			fileExtension: extension,
			
		});
		};
		reader.readAsDataURL(file);
  };

onsvgimgChangeHandler = (event) => {
    let reader = new FileReader();
    const file = event.target.files[0];
    const extension = file.name.split(".").pop();
    console.log(extension,"extension")
    reader.onloadend = () => {
      this.setState({
        imagesvg_name: file.name,
        imagesvg_preview: reader.result,
        imagesvg: file,
        imagesvg_fileExtension: extension,
        
      });
    };
    reader.readAsDataURL(file);
  };

	componentDidMount() {
		document.title = PageTitle('Loan Configuration Add');
		var admin_id = localStorage.getItem('admin_id');
	axios.get(apiUrl+'loantypes/getrequireddocument?admin_id='+admin_id)
		.then(res => {
			if(res.data.status == 'success'){

				this.setState({
					getrequireddocument:res.data.getrequireddocument
				});

			}else{
			}
		});
		this.loadGalleryImages();
    }

	loadGalleryImages = () => {
		axios.get(apiUrl + "loantypes/getimagelist").then(res => {
			if (res.data.status === 'success') {
				this.setState({ imagelist: res.data.imagelist || [] });
			}
		});
	};

	selectGalleryImage = (image) => {
		this.setState((prevState) => {
			const selectedImage = prevState.selectedImage?.name === image.name ? null : image;

			if (selectedImage) {
				// Fetch image and set appropriate form field
				const { lt_icontype } = prevState;
				const fieldType = lt_icontype === 'svg' ? 'image' : 'imagesvg';

				fetch(selectedImage.url)
					.then(res => res.blob())
					.then(blob => {
						const file = new File([blob], selectedImage.name, { type: blob.type });
						const reader = new FileReader();
						reader.onloadend = () => {
							if (fieldType === 'image') {
								this.setState({
									image: file,
									image_name: selectedImage.name,
									image_preview: reader.result,
									fileExtension: selectedImage.name.split('.').pop()
								});
							} else {
								this.setState({
									imagesvg: file,
									imagesvg_name: selectedImage.name,
									imagesvg_preview: reader.result,
									imagesvg_fileExtension: selectedImage.name.split('.').pop()
								});
							}
						};
						reader.readAsDataURL(blob);
					});
			}

			return {
				selectedImage,
				...(selectedImage && {
					enableuploadgalleyImage: false,
					enableuploadgalleyImageSvg: false
				})
			};
		});
	};

	renderGalleryImages = () => {
		const imageArr = this.state.imagelist;
		if (!imageArr || imageArr.length === 0) {
			return <li>No images found</li>;
		}
		return imageArr.map((image, index) => (
			<li className="gallery-multiselect-item position-relative" key={index}>
			
				{image.used === 'in_use' ? (
					<span className="gallery-inuse-badge position-absolute top-0 end-0 chip pointer-events-none">
						In use
					</span>
				) : (
					<span
						className="gallery-unlink-btn close-text position-absolute"                
						onClick={(e) => this.handleUnlinkClick(image, e)}
					>
						×
					</span>
				)}
				<input
					type="checkbox"
					className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
					value={image.name}
					checked={this.state.selectedImage?.name === image.name}
					onChange={() => this.selectGalleryImage(image)}
				/>
				<img src={image.url} alt={image.name || ''} />
			</li>
		));
	};

	handleUnlinkClick = (image, e) => {
		e.stopPropagation();
		e.preventDefault();
		axios.get(apiUrl + "loantypes/checkimageusage?imagename=" + image.name)
			.then(res => {
				if (res.data.status === 'success' && res.data.usagecount > 0) {
					this.setState({
						unlinkImage: image,
						imageUsageMessage: `This image is used in ${res.data.usagecount} listing(s) and cannot be unlinked.`,
						showUsageWarning: true
					});
				} else {
					this.setState({ unlinkImage: image, showUnlinkConfirm: true });
				}
			});
	};

	confirmUnlink = (answer) => {
		if (answer === 'yes') {
			const { unlinkImage } = this.state;
			const qs = require('qs');
			axios.post(apiUrl + "loantypes/unlinkimage", qs.stringify({ imagename: unlinkImage.name }))
				.then(res => {
					if (res.data.status === 'success') {
						this.setState(prev => ({
							imagelist: prev.imagelist.filter(img => img.name !== unlinkImage.name),
							selectedImage: prev.selectedImage?.name === unlinkImage.name ? null : prev.selectedImage,
							unlinkImage: null,
							showUnlinkConfirm: false
						}));
						$('.success_message').html('<div class="status_sucess"><h3>Image successfully unlinked from folder</h3></div>');
						setTimeout(() => {
							$('.success_message').html('');
						}, 3000);
					}
				});
		} else {
			this.setState({ unlinkImage: null, showUnlinkConfirm: false });
		}
	};

        handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				const formPayload = this.state;
				var selectedrequirmentidsd='';

				var qs = require('qs');
			
				const selectedrequirmentid = formPayload.selectedrequirmentid;
				var elements=[];
				let catList  = ''
				if(typeof selectedrequirmentid === 'object' && selectedrequirmentid!=='' && typeof selectedrequirmentid!==undefined && selectedrequirmentid!==null) {
					catList = selectedrequirmentid.map((number) =>
					elements.push(number.value)
				);
				selectedrequirmentidsd=elements.toString();

				}else{
					selectedrequirmentidsd=selectedrequirmentid;

				}
				const config = {
					headers: {
					"content-type": "multipart/form-data",
					},
				};
				
				var postObject = {
		
					admin_id:  localStorage.getItem("admin_id"),
					name: formPayload.name,
					requirements: selectedrequirmentidsd,
					category: formPayload.selectedPlanvalue,
					sort_order: formPayload.sort_order,
					status: formPayload.selectedvalue,
					id : formPayload.c_loanconfig_id,
					bank_statement_count : formPayload.bank_statement_count,
					old_image: this.state.old_image,
      				old_svgimage:this.state.old_svgimage,
					lt_icontype: formPayload.lt_icontype,
					image: formPayload.image,
					imagesvg: formPayload.imagesvg,
					starting_amount: this.calculateTotalAmount('starting'),
					display_starting_amount: formPayload.starting_amount+formPayload.starting_amount_type,
					ending_amount: this.calculateTotalAmount('ending'),
					display_ending_amount: formPayload.ending_amount+formPayload.ending_amount_type,
					showinTab: formPayload.showinTab,
					showinFormField: formPayload.showinFormField

				};
				 let formData = new FormData();
					Object.keys(postObject).forEach((key) => {
					if (postObject[key] !== undefined && postObject[key] !== null) {
						formData.append(key, postObject[key]);
					}
					});
				// console.log(postObject, 'post_obj');
				//this.props.getAddCompany(qs.stringify(postObject));
				
				axios.post(apiUrl+"loantypes/update",formData, config).then(res => {
					this.setState({Loading:false});
					if(res.data.status === "success"){		
					
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							//$('.success_message').html('');
							$('.success_message').html(this.props.history.push('/loantype'));
						}
						.bind(this),
						3000
						);
					 }else{
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					 }				 
					 
    	       });	
			}
	}
	handlePriceChange = (e) => {
		const inputValue = e.target.value;
	
		// You can format the input value with a currency symbol here
		if(inputValue!=''){
		const formattedPrice = inputValue.replace(/[^\d.]/g, '');

	    const priceWithSymbol = `$${formattedPrice}`;
	   

	
		this.setState({
			amount: priceWithSymbol
		  });
		}
	  };
	  validateForm() {
		const {name,selectedrequirmentid,sort_order,selectedPlanvalue,starting_amount,ending_amount} = this.state;
		let errors = {};
      	let formIsValid = true;
	
		if (!name) {
			formIsValid = false;
			$('.errorlabel').html('<span class="errorspan">Please fill the field</span>');
		}else if(name){
			$('.errorlabel').html('');
		}
		if (!selectedrequirmentid) {
			formIsValid = false;
			$('.errorselectedrequirmentid').html('<span class="errorspan">Please fill the field</span>');
		}else if(selectedrequirmentid){
			$('.errorselectedrequirmentid').html('');
		}
		if (!sort_order) {
			formIsValid = false;
			$('.errorsort_order').html('<span class="errorspan">Please fill the field</span>');
		}else if(sort_order){
			$('.errorsort_order').html('');
		}
		

		if (!selectedPlanvalue) {
			formIsValid = false;
			$('.errorcategory').html('<span class="errorspan">Please fill the field</span>');
		}else if(selectedPlanvalue){
			$('.errorcategory').html('');
		}

		if (!starting_amount) {
			formIsValid = false;
			$('.errorstarting_amount').html('<span class="errorspan">Please fill the field</span>');
		}else if(starting_amount){
			$('.errorstarting_amount').html('');
		}

		if (!ending_amount) {
			formIsValid = false;
			$('.errorending_amount').html('<span class="errorspan">Please fill the field</span>');
		}else if(ending_amount){
			$('.errorending_amount').html('');
		}

		if (starting_amount && ending_amount) {
			const startAmount = this.calculateTotalAmount('starting');
			const endAmount = this.calculateTotalAmount('ending');
			if (endAmount < startAmount) {
				formIsValid = false;
				$('.errorending_amount').html('<span class="errorspan">Ending amount must be greater than or equal to starting amount</span>');
			} else {
				$('.errorending_amount').html('');
			}
		}



		this.setState({
			errors: errors
		});
		return formIsValid;
    }

	handleClickSelecetCategory = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var keys = event.target.options[selectedIndex].getAttribute('data-key');
	
		this.setState({
				category_name: keys,	
		});
	
	}
	handleProductCategoryChange = (event) => {
		console.log(event,'event')
		this.setState({selectedrequirmentid : event}, function() {
		   const user_list = this.state.selectedrequirmentid;
		 
		});
	}

	calculateTotalAmount = (type = 'ending') => {
		const amountField = type === 'starting' ? 'starting_amount' : 'ending_amount';
		const typeField = type === 'starting' ? 'starting_amount_type' : 'ending_amount_type';
        //console.log(amountField, typeField,this.state[typeField],'amountField, typeField');
		const amount = this.state[amountField];
		if (!amount) return null;

		const parsedAmount = parseFloat(amount);
		const multipliers = {
			'K': 1000,
			'M': 1000000,
			'B': 1000000000,
			'T': 1000000000000
		};
		const multiplier = multipliers[this.state[typeField]] || 1;
		return parsedAmount * multiplier;
	}

	formatAmount = (amount) => {
		if (amount === null || amount === undefined) return '';
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(amount);
	}

  render() {
  	  const {selectedOption,selectedPlanOption,selectedrequirmentvalue,getrequireddocument} = this.state;
    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="loantype" />  

	
	<div className="content">	
		<div className="content-wrapper">
				  <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
							<div className="back-btn-lux">
								<a class="primary-btn" href="/loantype">Back</a> 
							</div> 
			<div className="title">
				<h4>Edit Details
</h4>				
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Loan<span class="required" style={{ color: "red" }} > * </span></label>
				    <input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name} />
					<div className="errorlabel"></div>
				</div>
				 <div className="form-group">
				    <label>Show loan type in </label>
					<div className="d-flex align-items-center gap-3">
					<div className="d-inline">
						<input
						onChange={this.handleInputChange}
						type="checkbox"
						name="showinTab"
						value="normal"
						checked={this.state.showinTab=="yes"}
						/>
						<span>Tab</span>
						</div>
						<div className="d-inline">
						<input
							onChange={this.handleInputChange}
							type="checkbox"
							name="showinFormField"
							value="svg"
							checked={this.state.showinFormField=="yes"}
						/>
						<span>Form field</span>
						</div>
                        
                      </div>
                </div>
				<div style={{ display: 'flex', gap: '20px' }}>
					<div className="form-group" style={{ flex: 1 }}>
						<label>Loan range from ($)<span class="required" style={{ color: "red" }} > * </span></label>
							<input type="text" name="starting_amount" onChange={this.handleInputChange} className="form-control" value={this.state.starting_amount} />
						<div className="errorstarting_amount"></div>
						{this.calculateTotalAmount('starting') && (
							<div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px', fontSize: '14px' }}>
								<strong>Loan range from:</strong> {this.formatAmount(this.calculateTotalAmount('starting'))}
							</div>
						)}
					</div>
					<div className="form-group" style={{ flex: 1 }}>
						<label>
							Amount Type
							<span className="required" style={{ color: "red" }}> * </span>
						</label>

						<select
							name="starting_amount_type"
							className="form-control"
							value={this.state.starting_amount_type}
							onChange={this.handleInputChange}
						>
							<option value="">Select Amount Type</option>
							{lang.common.amountType_options.map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>

						<div className="errorstarting_amount_type"></div>
					</div>
				</div>
				
				<div className="form-group">	
					<label>Required Documents </label>
					
					<Multiselect
						displayValue="label"
						onRemove={this.handleProductCategoryChange}

						onSelect={this.handleProductCategoryChange}
						value={this.state.selectedrequirmentid}
						selectedValues={selectedrequirmentvalue?getrequireddocument.filter(obj => selectedrequirmentvalue.includes(obj.value)):{ }}
						options={this.state.getrequireddocument}
						/>
					<div className="errorselectedrequirmentid"></div>
				 </div>
				 <div className="form-group">	
					<label>No of Bank statement required </label>

					<input type="text" name="bank_statement_count" onChange={this.handleInputChange} className="form-control" value={this.state.bank_statement_count} />
					<div className="errorbank_statement_count"></div>
				 </div>
				  <div className="form-group">
                       <label>Image Type</label>
                           <div className="d-flex align-items-center gap-3">
                          <div className="d-inline">
                              <input
                                onChange={this.handleInputChange}
                                type="radio"
                                name="lt_icontype"
                                value="normal"
                                checked={this.state.lt_icontype=="normal"}
                              />
                              <span>Normal</span>
                              </div>
                             <div className="d-inline">
                                <input
                                  onChange={this.handleInputChange}
                                  type="radio"
                                  name="lt_icontype"
                                  value="svg"
                                  checked={this.state.lt_icontype=="svg"}
                                />
                                <span>3D Icon</span>
                              </div>
                        
                      </div>
                  </div>
				   {this.state.lt_icontype==='svg' &&(
				   <div className="form-group">
                      <label className="form-label fw-semibold">Upload 3d icon for white theme (jpeg,jpg,png,svg)</label>
                      <div className="d-flex gap-3 flex-wrap align-items-center">
                        <i onClick={() => this.setState({ enableuploadgalleyImage: true })} style={{ cursor: 'pointer' }}>
                          <svg width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">
                            <path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path>
                          </svg>
                        </i>
                        {this.state.image_preview && (
                          <img
                            className="img_class"
                            src={this.state.image_preview}
                            alt="Preview"
                          />
                        )}
                      </div>                      

                      <div className="errorfile"></div>
                    </div>

					 )}
                      <div className="form-group">
                        <label className="form-label fw-semibold">{this.state.lt_icontype == 'svg' ? 'Upload SVG icon for other themes (only svg)' : 'Upload SVG icon (only svg)'}</label>

                      <div className="d-flex gap-3 flex-wrap align-items-center">
                        <i onClick={() => this.setState({ enableuploadgalleyImageSvg: true })} style={{ cursor: 'pointer' }}>
                          <svg width="20px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="4.76 4.76 90.49 90.48">
                            <path d="m95.238 82.742v11.203c0 1.4141-1.4375 1.293-2.1523 1.293h-87.035c-1.4141 0-1.293-1.4375-1.293-2.1523l0.003907-11.203c0-1.4141 1.4375-1.293 2.1523-1.293h87.031c1.418 0 1.293 1.4336 1.293 2.1523zm-30.668-44.543v34.586h-29.141v-34.586h-16.645c-1.1523 0-1.7305-1.3906-0.91406-2.207l30.605-30.602c0.83984-0.83984 2.207-0.83984 3.0469 0l30.605 30.605c0.81641 0.81641 0.23828 2.207-0.91406 2.207z"></path>
                          </svg>
                        </i>
                        {this.state.imagesvg_preview!='' ? (
                          <img
                            className="img_class"
                            src={this.state.imagesvg_preview}
                            alt="Preview_SVG"
                          />
                        ) : (this.state.selectedImage && (
                          <img
                            className="img_class"
                            src={this.state.selectedImage.url}
                            alt="Preview"
                          />
                        ))}
                      </div>                      

                      <div className="errorfile"></div>
                    </div>
                   
				
			</div>
			
			<div className="form-right">	
			<div className="form-group">					
					<label> Category<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   value={selectedPlanOption?selectedPlanOption:""}
                            options={lang.common.loantype_option} 
                            onChange={this.handlecatChange.bind(this)}
                            />
							<div className="errorcategory"></div>
	        </div> 
			<div className="form-group">
				<label>Priority<span class="required" style={{ color: "red" }} > * </span> : </label>
				<input type="number" name="sort_order" onChange={this.handleInputChange} className="form-control" value={this.state.sort_order} />
				<div className="errorsort_order"></div>
			</div>
			<div style={{ display: 'flex', gap: '20px' }}>
					<div className="form-group" style={{ flex: 1 }}>
						<label>Loan range upto ($) <span class="required" style={{ color: "red" }} > * </span></label>
							<input type="text" name="ending_amount" onChange={this.handleInputChange} className="form-control" value={this.state.ending_amount} />
						<div className="errorending_amount"></div>
						{/* <div className="erroramount_comparison"></div> */}
						{this.calculateTotalAmount() && (
							<div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '4px', fontSize: '14px' }}>
								<strong>Loan range upto:</strong> {this.formatAmount(this.calculateTotalAmount('ending'))}
							</div>
						)}
					</div>
					<div className="form-group" style={{ flex: 1 }}>
						<label>
							Amount Type
							<span className="required" style={{ color: "red" }}> * </span>
						</label>
	
						<select
							name="ending_amount_type"
							className="form-control"
							value={this.state.ending_amount_type}
							onChange={this.handleInputChange}
						>
							<option value="">Select Amount Type</option>
							{lang.common.amountType_options.map((option) => (
								<option key={option.value} value={option.value}>
									{option.label}
								</option>
							))}
						</select>
	
						<div className="errorending_amount_type"></div>
					</div>
				</div>
			  
				
                
				<div className="default-font">
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span></label>
						   <Select 
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
                            onChange={this.handleChange}
                            />
				</div>
				</div>
				
			</div>	
			</div>		

			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
									<span className="load-data"></span> 
									}Submit
			   </button>
			</div>
			</form>
			</div>

		</div>

		<div className={`popup-sec popup-upload-media ${this.state.enableuploadgalleyImage ? 'active' : ''}`}>
			<div className='popup-sec-in'>
				<span className='popup-close position-absolute cursor-pointer' onClick={() => this.setState({ enableuploadgalleyImage: false })}>X</span>
				<div className='d-flex mb-4'>
				<div className="upload-file-icon upload-file-with-label position-relative cursor-pointer lh-1 d-flex align-items-baseline gap-20px">
					<input type="file" className="position-absolute top-0 opacity-0 h-100 w-100 cursor-pointer" />
					<p className="fw-semibold m-0 me-2">Upload from device</p>
					<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
				</div>
				</div>
				<ul className="gallery-multiselct-sec d-flex gap-4 flex-wrap mt-30px">
				{this.renderGalleryImages()}
				</ul>
			</div>
		</div>

		<div className={`popup-sec popup-upload-media ${this.state.enableuploadgalleyImageSvg ? 'active' : ''}`}>
			<div className='popup-sec-in'>
				<span className='popup-close position-absolute cursor-pointer' onClick={() => this.setState({ enableuploadgalleyImageSvg: false })}>X</span>
				<div className='d-flex mb-4'>
				<div className="upload-file-icon upload-file-with-label position-relative cursor-pointer lh-1 d-flex align-items-baseline gap-20px">
					<input type="file" className="position-absolute top-0 opacity-0 h-100 w-100 cursor-pointer" accept=".svg,image/svg+xml" />
					<p className="fw-semibold m-0 me-2">Upload from device</p>
					<span className="profile_btn"><input type="file" name="file" accept=".svg,image/svg+xml" onChange={this.onsvgimgChangeHandler} /></span>
				</div>
				</div>
				<ul className="gallery-multiselct-sec d-flex gap-4 flex-wrap mt-30px">
				{this.renderGalleryImages()}
				</ul>
			</div>
		</div>

		{this.state.showUnlinkConfirm && (
			<div className="confirm-action show">
				<p>Are you sure you want to unlink this image from the gallery?</p>
				<a href="javascript://" onClick={() => this.confirmUnlink('yes')} className="btn">Yes</a>
				<a href="javascript://" onClick={() => this.confirmUnlink('no')} className="btn">No</a>
			</div>
		)}

		{this.state.showUsageWarning && (
			<div className="confirm-action show">
				<p>{this.state.imageUsageMessage}</p>
				<a href="javascript://" onClick={() => this.setState({ showUsageWarning: false, unlinkImage: null })} className="btn">OK</a>
			</div>
		)}
	</div>

	    </div>
    );
  }
}


/*const mapStateTopProps = (state) => {
  return {
  	companyadd: state.companyadd
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
	 getAddCompany: (formPayload) =>{
       dispatch({ type: GET_ADDLOANCONFIG, formPayload});
    }
  }
}*/

export default (withRouter(Edit));